import { Check, ContentCopy } from '@mui/icons-material';
import { Box, SxProps, Typography } from '@mui/material';
import { theme } from '../utils/theme';
import { useState } from 'react';

const CopyToClipboard = ({
  children,
  displayText,
  sx,
}: {
  children: string;
  displayText?: string;
  sx?: SxProps;
}) => {
  if (typeof children !== 'string') {
    throw new Error('CopyToClipboard component must be used with a string');
  }
  const [copied, setCopied] = useState(false);
  return (
    <Box
      component="span"
      sx={{ display: 'flex', alignItems: 'center', ...(sx || {}) }}
    >
      <Typography
        variant="body2"
        fontFamily={'Source Serif Pro'}
        fontWeight={700}
        sx={{
          width: 'fit-content',
          color: copied ? 'success.light' : '#3174AB',
          cursor: 'pointer',
          borderRadius: '4px',

          padding: '4px 8px',
          backgroundColor: '#3174AB1A',
        }}
      >
        {copied ? 'copied' : displayText || children}
      </Typography>
      {copied ? (
        <Check color="success" />
      ) : (
        <ContentCopy
          sx={{
            fontSize: '1rem',
            marginLeft: '4px',
            verticalAlign: 'middle',
            cursor: 'pointer',
            backgroundColor: theme.palette.grey[50],
          }}
          onClick={(e) => {
            e.stopPropagation();
            navigator.clipboard.writeText(children);
            setCopied(true);
            setTimeout(() => {
              setCopied(false);
            }, 2000);
          }}
        />
      )}
    </Box>
  );
};

export default CopyToClipboard;
